export class Login {
    constructor() {
        this.loginPanel = $("#login-panel");
        this.recoverPasswordPanel = $("#recover-password-panel");
        $("#switch-recover-button").on("click", (e) => {
            e.preventDefault();
            this.showRecoverPanel();
        });
        $("#switch-login-button").on("click", (e) => {
            e.preventDefault();
            this.showLoginPanel();
        });
    }
    showRecoverPanel() {
        this.recoverPasswordPanel.removeClass("hidden");
        this.loginPanel.addClass("hidden");
    }
    showLoginPanel() {
        this.loginPanel.removeClass("hidden");
        this.recoverPasswordPanel.addClass("hidden");
    }
}
